module.exports = __webpack_public_path__ + "img/Weapon_45.76848208.png";